import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Broadcast } from "@phosphor-icons/react";
import api from "@/lib/api";

export default function Login() {
  const navigate = useNavigate();
  const [mobile, setMobile] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await api.post("/proxy/auth/login", { mobile_number: mobile, password });
      localStorage.setItem("token", r.data.access_token);
      localStorage.setItem("user", JSON.stringify(r.data.user));
      navigate("/");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed. Check your credentials.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex">
      <div className="flex-1 flex items-center justify-center px-8">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="login-form">
          <div className="flex items-center gap-2 mb-10">
            <Broadcast size={28} weight="duotone" className="text-[#007AFF]" />
            <span className="font-heading font-extrabold tracking-tight text-2xl">SalesTrack Pro</span>
          </div>
          <p className="text-xs uppercase tracking-[0.2em] text-slate-500 mb-2">Admin Console</p>
          <h1 className="font-heading font-black tracking-tight text-4xl mb-8">Command your field force.</h1>
          <label className="block text-sm font-medium mb-1.5">Mobile Number</label>
          <input
            data-testid="login-mobile-input"
            value={mobile}
            onChange={(e) => setMobile(e.target.value)}
            placeholder="9999999999"
            className="w-full border border-slate-300 rounded-md px-3 py-2.5 text-sm font-mono-data focus:outline-none focus:ring-2 focus:ring-[#007AFF] mb-4"
            required
          />
          <label className="block text-sm font-medium mb-1.5">Password</label>
          <input
            data-testid="login-password-input"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••"
            className="w-full border border-slate-300 rounded-md px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#007AFF] mb-6"
            required
          />
          <button
            data-testid="login-submit-btn"
            disabled={loading}
            className="w-full bg-[#007AFF] text-white rounded-md py-2.5 text-sm font-semibold hover:bg-[#0066d6] transition-colors duration-150 disabled:opacity-60"
          >
            {loading ? "Signing in..." : "Sign In"}
          </button>
          <p className="text-xs text-slate-400 mt-6">Use the same credentials as your SalesTrack Pro mobile app.</p>
        </form>
      </div>
      <div className="hidden lg:block w-[45%] relative border-l border-slate-200">
        <img
          src="https://images.pexels.com/photos/38251243/pexels-photo-38251243.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
          alt="Topography map"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-slate-950/60 flex items-end p-10">
          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-slate-300 mb-2">Field Force Tracking</p>
            <p className="font-heading font-bold text-white text-2xl tracking-tight max-w-md">
              Live GPS, attendance, visits and reports — synced with your mobile team in real time.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
